module.exports = __webpack_public_path__ + "static/media/boxEffectSix.0497b822.png";